import { ChangeEvent, useState } from "react";
import { toast } from "react-toastify";
import { Card, CardBody, Col, Form } from "reactstrap";
import { Btn } from "../../../../../../AbstractElements";
import { Previous, StudentValidationFormTitle } from "../../../../../../Constants/Constants";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import BasicInfoForm from "./BasicInfoForm";
import ProfileForm from "./ProfileForm";
import SocialLinksForm from "./SocialLinksForm";
import { StudentValidationFormSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormLayout";
import FinishForm from "../NumberingWizard/FinishForm";

const StudentValidationForm = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({ name: "", email: "", password: "", confirmPassWord: "", portfolioURL: "", projectDescription: "", imageUpload: "", twitterUrl: "", gitHubUrl: "", studentFile: "", positions: "", positionQuestion: "" });
  const [showSubmit, setShowSubmit] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const handleSubmitButton = () => toast.success("Successfully Completed");

  const updateFormData = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const value = name === "agreeTerms" || name === "informationCheckBox" || name === "agreeConditions" ? event.target.checked : name === "imageUpload" || name === "studentFile" ? event.target.files?.[0] : event.target.value;
    if (name === "imageUpload") {
      const file = value as File | undefined;
      const reader = new FileReader();
      reader.onload = () => {
        const uploadedImageUrl = reader.result as string;
        setSelectedImage(uploadedImageUrl);
      };
      if (file) reader.readAsDataURL(file);
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleBackButton = () => {
    setShowSubmit(false);
    setStep((prev) => prev - 1);
  };
  const handleNextButton = () => {
    const { password, name, email, confirmPassWord, portfolioURL, projectDescription, imageUpload, twitterUrl, gitHubUrl, studentFile, positions, positionQuestion } = formData;
    if (name !== "" && email !== "" && password !== "" && confirmPassWord !== "" && step === 1) setStep(2);
    else if (projectDescription !== "" && portfolioURL !== "" && imageUpload !== "" && step === 2) setStep(3);
    else if (twitterUrl !== "" && gitHubUrl !== "" && studentFile !== "" && positions !== "" && positionQuestion !== "" && step === 3) {
      setStep(4);
      setShowSubmit(true);
    } else return toast.error("please fill out all the fields before moving on to the next step");
  };
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={StudentValidationFormTitle} span={StudentValidationFormSubTitle} />
        <CardBody className="custom-input">
          <Form className="form-wizard" onSubmit={(e) => e.preventDefault()}>
            <div className={`tab ${step === 1 ? "d-block" : "d-none"}`}>
              <BasicInfoForm formData={formData} updateFormData={updateFormData} />
            </div>
            <div className={`tab ${step === 2 ? "d-block" : "d-none"}`}>
              <ProfileForm formData={formData} updateFormData={updateFormData} selectedImage={selectedImage} />
            </div>
            <div className={`tab ${step === 3 ? "d-block" : "d-none"}`}>
              <SocialLinksForm formData={formData} updateFormData={updateFormData} />
            </div>
            {step === 4 && <FinishForm />}
            <div className="text-end pt-3">
              {step > 1 && (<Btn color="secondary" className="me-1" onClick={handleBackButton}>{Previous}</Btn>)}
              <Btn color="primary" onClick={showSubmit ? handleSubmitButton : handleNextButton}>{showSubmit ? "Submit" : "Next"}</Btn>
            </div>
            <div className="text-center">
              <span className={`step ${step === 1 ? "active" : ""}`} />
              <span className={`step ${step === 2 ? "active" : ""}`} />
              <span className={`step ${step === 3 ? "active" : ""}`} />
              <span className={`step ${step === 4 ? "active" : ""}`} />
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default StudentValidationForm;
